export interface FilterValues {
    statusList: number[];
    datumVon: string;
    datumBis: string;
    kNr?: number;
    kName?: string;
    kundePlzVon?: string;
    kundePlzBis?: string;
    kundeUmsatzTsdVon: number;
    kundeUmsatzTsdBis: number;
    kundeBranchen?: number[];
    kundeInteresseFuerProdukte?: number[];
    kundeErweiterteSuchen?: number[];
    kundeBetreuer?: number;
    kundeTelBetreuer?: number;
    betreuer?: number;
    betreuerGebiet?: boolean;
    telBetreuer?: number;
    telBetreuerGebiet?: boolean;
    artikelGruppeNr?: number;
    produktgruppen?: number[];
    showBetreuer?: boolean;
    showTelBetreuer?: boolean;
    showDetails?: boolean;
    previousYear1?: boolean;
    previousYear2?: boolean;
    previousYear3?: boolean;
}

export interface LineData {
    aNr: string;
    kNr: number;
    kName: string;
    datum: string;
    count: number;
    betreuerNr: number;
    name: string;
    ablehnGrund: number;
    ekNetto: number;
    vkNetto: number;
    bMarge: number;
    // tippProv: number;
    skonto: number;
    // fracht: number;
    nMarge: number;
    bAnteil: number;
    fAnteil: number;
    betrUmCount: number;
    betrUm: number;
}

export const defaultLineData: LineData = {
    aNr: '',
    kNr: 0,
    kName: '',
    datum: '',
    betreuerNr: 0,
    count: 0,
    name: '',
    ablehnGrund: 0,
    ekNetto: 0,
    vkNetto: 0,
    bMarge: 0,
    // tippProv: 0,
    skonto: 0,
    // fracht: 0,
    nMarge: 0,
    bAnteil: 0,
    fAnteil: 0,
    betrUmCount: 0,
    betrUm: 0,
};

export interface AngebotSummary {
    loading: boolean;
    count: number;
    total: LineData;
    betreuerTotal: {
        [key: number]: LineData;
    };
    telBetreuerTotal: {
        [key: number]: LineData;
    };
    angebotLineDataList: LineData[];
    fAnteilTotal: number;
}
